import { Card } from "@bcc/components/ui/card";
import { cn } from "@bcc/lib/utils";
import { getServiceTileTestId, ServiceTilePlatform } from "./service-tile.utils";

interface ServiceTileProps {
  platform: ServiceTilePlatform;
  label: string;
  description: string;
  onClick: () => void;
  testId?: string;
}

function ServiceTile({ platform, label, description, onClick, testId }: Readonly<ServiceTileProps>) {
  const isShopify = platform === "shopify";

  return (
    <Card
      testId={testId ?? getServiceTileTestId(platform)}
      className="group flex flex-1 cursor-pointer flex-col items-center gap-4 border-2 border-border p-6 text-center transition-all hover:scale-105 hover:border-primary hover:shadow-lg"
      onClick={onClick}
    >
      <div
        className={cn(
          "flex h-16 w-16 items-center justify-center rounded-full transition-colors",
          isShopify ? "bg-[#96BF48]/10" : "bg-[#7F54B3]/10"
        )}
      >
        <img
          src={isShopify ? "/images/shopify-logo.svg" : "/images/woocommerce-logo.svg"}
          alt={`${platform} logo`}
          width={40}
          height={40}
          className="h-10 w-10"
        />
      </div>
      <div className="flex flex-col gap-2">
        <h3 className="text-lg font-semibold text-text-primary">{label}</h3>
        <p className="text-sm text-text-muted">{description}</p>
      </div>
    </Card>
  );
}

export { ServiceTile };
